import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/20/solid';

import StyledLabel from './styled-label';

interface ComponentProps {
  children: React.ReactNode;
  title: string;
  error: string | undefined;
  hasStar?: boolean;
}

function LabelWithError({ children, title, error, hasStar }: ComponentProps) {
  return (
    <>
      <StyledLabel>
        {title}
        {hasStar && <span className="text-red-700">*</span>}
      </StyledLabel>
      <div className="relative rounded-md shadow-sm">
        {children}
        {error && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
          </div>
        )}
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600" id="email-error">
          {error}
        </p>
      )}
    </>
  );
}

LabelWithError.defaultProps = {
  hasStar: false,
};

export default LabelWithError;
